import { ChangeDetectionStrategy, Component, OnInit, ViewChild } from '@angular/core'
import { RegisteredUser } from '@ftr/contracts/api/user'
import { ScreenSizeService } from '@ftr/foundation'
import { DropdownMenuLegacyComponent, StaticMenuItem } from '@ftr/menus'
import { SideNavComponent } from '@ftr/ui-core'
import { UserState } from '@ftr/ui-user'
import { Store } from '@ngxs/store'
import { Observable, filter, map } from 'rxjs'
import { AccountMenuItemsProvider } from '../../../services/navigation/account-menu-items.provider'

@Component({
  selector: 'ftr-account-menu',
  templateUrl: './account-menu.component.html',
  styleUrls: ['./account-menu.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AccountMenuComponent implements OnInit {
  @ViewChild(SideNavComponent) sideNav: SideNavComponent
  @ViewChild(DropdownMenuLegacyComponent) dropdown: DropdownMenuLegacyComponent

  userFullName$: Observable<string>
  accountMenuItems$: Observable<StaticMenuItem[]>

  constructor(
    protected readonly screenSizeService: ScreenSizeService,
    private readonly accountMenuItemsProvider: AccountMenuItemsProvider,
    private readonly store: Store,
  ) {}

  ngOnInit(): void {
    this.accountMenuItems$ = this.accountMenuItemsProvider.provide()
    this.observeCurrentUser()
  }

  toggle(): void {
    if (this.screenSizeService.isMobile()) {
      this.sideNav.toggle()
    } else {
      this.dropdown.toggle()
    }
  }

  private observeCurrentUser(): void {
    this.userFullName$ = this.store.select(UserState.user).pipe(
      filter(userData => userData.isSuccess()),
      map(userData => {
        const currentUser = userData.data as RegisteredUser
        return `${currentUser.givenName} ${currentUser.familyName}`
      }),
    )
  }
}
